module.exports = __webpack_public_path__ + "media/Battle of Heroes.91218113.mp3";